export default __webpack_public_path__ + "static/media/nex.svg.5d275b41.png";